import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import img from 'img/family-content/empty-new-block-family-documents.png';
import imgDark from 'img/family-content/empty-new-block-family-documents-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { familyDocumentsEnableAction } from 'reactApp/modules/family/family.actions';
import baseStyles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';
import { renderFamilyDocumentsModal } from 'reactApp/ui/FamilyDocumentsModal/FamilyDocumentsModal.helper';

import styles from './FamilyContentNewEmptyCards.css';

export const FamilyDocumentsEmptyState = (): ReactElement => {
    const dispatch = useDispatch();

    const onClick = () => {
        xray.send('empty-family-docs-recognition-on', { p: 'cloud' });
        renderFamilyDocumentsModal({
            onClick: () => {
                dispatch(familyDocumentsEnableAction());
            },
        });
    };
    return (
        <div id="family-card-docs" className={`${baseStyles.card}`} onClick={onClick} data-qa-id="family-subscription">
            <Title level="2" data-qa-id="family-subscription-title">
                Соберите&nbsp;документы&nbsp;семьи
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-subscription-content">
                Включите распознавание, и Облако
                <br />
                само найдёт и разложит документы
            </Text>
            <Spacing size={20} style={{ pointerEvents: 'none' }} />
            <Button
                mode="primary"
                appearance="accent-invariable"
                size="l"
                className={styles.button}
                data-qa-id="family-subscription-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                Собрать документы
            </Button>
            <img
                src={isDarkTheme ? imgDark : img}
                alt="Близкие в подписке"
                className={styles.image}
                data-qa-id="family-subscription-mascot"
            />
        </div>
    );
};
